import type { IDesignRequestRepository, DesignRequestListQuery } from '@domain/data-contracts/design-request-repository.interface';
import type { DesignRequest } from '@domain/models/design-request.interface';
import type { PagedResult } from '@domain/models/paging.interface';

export class DesignRequestsService {
  public constructor(private readonly repo: IDesignRequestRepository) {}

  public list(query: DesignRequestListQuery): Promise<PagedResult<DesignRequest>> {
    return this.repo.list(query);
  }
}
